// extracted by mini-css-extract-plugin
export default {"h3":"ListTitle_h3__cOrn2","inboarding":"ListTitle_inboarding__FYCWb","upper":"ListTitle_upper__7zXl9"};